import { memo } from 'react';
import { panelLead, panelTitle } from './panelHeader.styles.js';

export interface SettingsPageHeroProps {
  readonly initials: string;
  readonly eyebrow: string;
  readonly title: string;
  readonly lead: string;
  readonly className?: string;
}

export const SettingsPageHero = memo(
  ({ initials, eyebrow, title, lead, className = '' }: SettingsPageHeroProps): JSX.Element => {
    const rootClass = [
      'rounded-xl border border-[color-mix(in_srgb,var(--color-an-primary)_15%,white)]',
      'bg-gradient-to-br from-[color-mix(in_srgb,var(--color-an-primary)_8%,white)] to-white p-5',
      className,
    ]
      .filter((part) => part.length > 0)
      .join(' ');

    return (
      <header className={rootClass} data-testid="settings-page-hero">
        <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:items-center">
          <div className="flex items-center gap-4">
            <div
              className="flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-full bg-[var(--color-an-primary)] text-lg font-bold text-[var(--color-an-on-primary,#ffffff)]"
              aria-hidden="true"
            >
              {initials}
            </div>
            <div>
              <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-[var(--color-an-text-muted)]">
                {eyebrow}
              </p>
              <h2 className={panelTitle({ className: 'm-0' })}>{title}</h2>
            </div>
          </div>
          <p className={panelLead({ className: 'm-0' })}>{lead}</p>
        </div>
      </header>
    );
  },
);

SettingsPageHero.displayName = 'SettingsPageHero';
